import * as React from 'react';
import ReactDatePicker from 'react-datepicker';

import * as stylesDatepicker from './reactDatePicker.scss';
import * as styles from './styles.scss';
import Calendar from 'components/svg/Calendar';
import moment from 'moment';
import { translate } from 'utils/translateUtil';

interface Props {
    className?: any;
    placeholderText?: any;
    label: string;
    name: string;
    date?: any;
    onDateChange?: any;
    reset?: any;

    startDate?: any;
    endDate?: any;

    minDate?: any;
    maxDate?: any;
}

class SantaderDatepicker extends React.Component<Props, any> {
    private datePickerRef = React.createRef<ReactDatePicker>();
    public constructor(props: Props) {
        super(props);
        this.state = {
            isActive: false,
            errorMsg: '',
            classColor: ''
        };
    }

    public handleChange = (date: Date) => {
        const { name } = this.props;
        this.props.onDateChange({
            [name]: this.getDate(date)
        });
    };

    public enrichedOnFocus = () => {
        this.setState({
            isActive: true
        });
    };
    public onBlurDiv = () => {
        this.setState({
            isActive: false
        });
    }
    public enrichedOnBlur = (ev:any) => {
        this.handleChange(
            new Date(moment(ev.target.value, 'DD.MM.YYYY').toString())
        );
    };
    public getDate = (date: Date) => {
        this.setState({classColor: this.validateDate(date) ? 'valid' : 'error'})
        const validatedDate = this.validateDate(date)
            ? date
            : new Date(Date.now());
        return validatedDate;
    };
    public validateDate = (date:any) => {
        if(!date){
            return false
        }
        this.setState({ errorMsg: '' });
        const minDate = new Date('01/01/1900');
        const maxDate = new Date(Date.now());
        const validate = date.toDateString() === 'Invalid Date';
        if (validate) {
            this.setState({
                errorMsg: translate('transfers.invalidDate.date')
            });
            return false;
        }
        const value = moment(date).isBetween(
            minDate,
            maxDate,
            // @ts-ignore
            null,
            '[]'
        );
        const greaterThan = moment(date).isSameOrAfter(minDate);
        const lowerThan = moment(date).isSameOrBefore(maxDate);
        if (!greaterThan) {
            this.setState({
                errorMsg: translate('invalidDate.minDate')
            });
        }
        if (!lowerThan) {
            this.setState({
                errorMsg: translate('invalidDate.invalidDateFuture')
            });
        }
        return value;
    };
    public openCalendar = () => {
        // @ts-ignore
        this.setState({isActive: !this.datePickerRef.current.isCalendarOpen()});
        // @ts-ignore
        this.datePickerRef.current.setOpen(
            // @ts-ignore
            !this.datePickerRef.current.isCalendarOpen()
        );
    };
    public componentDidUpdate(props: any) {
        if (
            this.props.minDate &&
            moment(this.props.minDate).isAfter(this.props.date)
        ) {
            this.handleChange(this.props.minDate);
        }
        if (
            this.props.maxDate &&
            this.props.date &&
            moment(this.props.maxDate).isBefore(this.props.date)
        ) {
            this.handleChange(this.props.maxDate);
        }
    }
    
    public render() {
        const {
            date,
            label,
            name,
            placeholderText,
            // startDate,
            // endDate,
            // minDate,
            // maxDate,
            className
        } = this.props;

        const { isActive, classColor } = this.state;
        return (
            <>
                <div onBlur={this.onBlurDiv}
                    className={
                        `${className} ` +
                        styles.wrapper +
                        ' ' +
                        styles.santanderDatepicker +
                        (isActive ? ' ' + styles.isFilled : ' ' + styles.blur) +
                        ' ' + styles[classColor]
                    }
                >
                    <label className={styles.label}>{label}</label>
                    <ReactDatePicker
                        ref={this.datePickerRef}
                        name={name}
                        selected={date}
                        onChange={this.handleChange}
                        className={styles.input}
                        calendarClassName={stylesDatepicker.popper}
                        adjustDateOnChange={true}
                        placeholderText={placeholderText}
                        dateFormat="dd.MM.yyyy"
                        onFocus={this.enrichedOnFocus}
                        onBlur={this.enrichedOnBlur}
                    />
                    <div
                        className={styles.iconWrapper}
                        onClick={this.openCalendar}
                    >
                        <Calendar />
                    </div>
                </div>
                {this.state.errorMsg ? (
                    <p className={styles.isSublineError}>
                        {this.state.errorMsg}
                    </p>
                ) : (
                    ''
                )}
            </>
        );
    }
}

export default SantaderDatepicker;
